import { deleteObject, ref } from "firebase/storage";
import { storage } from "../config/firebase.config";

export const filters = [
  { id: 2, name: "Anthems", value: "anthems" },
  { id: 3, name: "Hymns", value: "hymns" },
  { id: 4, name: "Spiritual Songs", value: "spiritual songs" },
  { id: 5, name: "Choruses", value: "choruses" },
];

export const filterByLanguage = [
  { id: 1, name: "English", value: "english" },
  { id: 2, name: "Efik", value: "efik" },
  { id: 3, name: "Igbo", value: "igbo" },
  { id: 4, name: "Bayaelsa", value: "bayaelsa" },
  { id: 6, name: "Biakpan", value: "biakpan" },
  { id: 5, name: "Others", value: "others" },
];

export const deleteAnObject = (referenceUrl) => {
  const deleteRef = ref(storage, referenceUrl);
  deleteObject(deleteRef)
    .then(() => {
      return true;
    })
    .catch((error) => {
      return false;
    });
};
